import { useWidget } from '@telescope/cassini-hooks';
import { Link, Button, Flex, Spacer } from '@telescope/cassini-ui';
import { Campaign } from 'types';

export const RulesButton = () => {
  const { data: rulesData } = 
    useWidget({ select: (data: Campaign) => data.widget.global_views.rules });
  const { content: { rulesLink } } = rulesData!;

  if (!rulesLink) return null;

  return (
    <Flex direction="column" maxW="app" align="center" mb={4}>
      <Spacer />
      <Button as={Link} href={rulesLink.url} isExternal
              variant="solidBold" borderRadius="full" fontSize="sm" px={4} py={2} height="auto">
        {rulesLink.copy}
      </Button>
    </Flex>
  )
}